import { useState, forwardRef } from 'react';

import type { TextFieldModel } from '../../../types';
import IconButton from '../../Button/Icon';
import Icon from '../../Icon';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './PasswordTextField.module.scss';

export interface PasswordTextFieldProps extends TextFieldModel {
  hasEyesIcon?: boolean;
}

const PasswordTextField = forwardRef<HTMLInputElement, PasswordTextFieldProps>(({ success, hasEyesIcon = true, ...props }, ref) => {
  const [isShow, setShow] = useState(false);

  const handleClick = () => {
    setShow(!isShow);
  };

  return (
    <BaseStyleTextField type={isShow ? 'text' : 'password'} textSecurity={!isShow} {...props} ref={ref}>
      {success && <Icon className={s.icon} type="check-mark" size={24} color="green.600" />}
      {hasEyesIcon && <IconButton icon={isShow ? 'eyes-open' : 'eyes-close'} color="gray.500" onClick={handleClick} />}
    </BaseStyleTextField>
  );
});

export default PasswordTextField;
